import assign from '../assign/index.js';
export default function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/cloneObject/index.js
// module id = 297
// module chunks = 27